import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const HouseVisitsMadeToEachStudentMonthly = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="House visits made to each student monthly" />
    </Box>
  );
};
